"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoType = void 0;
var VideoType;
(function (VideoType) {
    VideoType["Raw"] = "raw";
    VideoType["YouTube"] = "youtube";
})(VideoType = exports.VideoType || (exports.VideoType = {}));
